<template>
  <v-menu
    v-model="open"
    left
    transition="scroll-y-transition"
    :nudge-bottom="50"
    :min-width="196"
    :max-width="360"
    :close-on-content-click="false"
    content-class="c360-menu"
  >
    <template #activator="{ attrs, on }">
      <v-btn
        rounded
        class="c360-button"
        v-on="on"
        v-bind="attrs"
        @click="$emit(open ? 'deactivated' : 'activated')"
      >
        <span :style="{ color: open ? 'rgba(255, 255, 255, 0.5)' : 'white' }">
          {{ currentAdvertiser || 'Select Advertiser' }}
        </span>
        <c360-icon v-if="open" icon="Close_SM" color="c360-charcoal" />
        <c360-icon v-else icon="Caret_Down_SM" color="c360-charcoal" />
      </v-btn>
    </template>
    <v-card :loading="loading">
      <v-sheet class="px-4 py-3">
        <slot name="input" />
      </v-sheet>
      <v-sheet v-if="items.length">
        <v-virtual-scroll height="190" :item-height="itemHeight" :items="items">
          <template #default="{ item }">
            <v-list-item :key="item.name" two-line @click="onItemClick(item)">
              <v-list-item-content>
                <v-list-item-subtitle v-if="item.agency">{{ item.agency }}</v-list-item-subtitle>
                <v-list-item-title class="font-weight-bold" v-if="item.name">
                  <v-tooltip right>
                    <template #activator="{ on, attrs }">
                      <span v-on="on" v-bind="attrs">{{ item.name }}</span>
                    </template>
                    {{ item.name }}
                  </v-tooltip>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-virtual-scroll>
      </v-sheet>
      <v-sheet v-else-if="loading" height="80" class="px-6 py-4">
        <p class="mb-0">{{ loadingText }}</p>
      </v-sheet>
      <v-sheet v-else height="80" class="px-6 py-4">
        <p class="mb-0">No advertiser found for this keyword.</p>
        <p>Please try something else.</p>
      </v-sheet>
      <v-sheet v-if="recent.length" color="c360-gray2">
        <p class="mb-0 c360-gray--text font-weight-medium px-4 pt-3">Recent advertisers</p>
        <v-list color="transparent">
          <v-list-item
            v-for="item in recent"
            :key="item.name"
            two-line
            class="px-0 px-4"
            @click="onRecentClick(item)"
          >
            <v-list-item-content>
              <v-list-item-subtitle>{{ item.agency }}</v-list-item-subtitle>
              <v-list-item-title class="font-weight-bold">
                <v-tooltip right>
                  <template #activator="{ on, attrs }">
                    <span v-on="on" v-bind="attrs">{{ item.name }}</span>
                  </template>
                  {{ item.name }}
                </v-tooltip>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-sheet>
    </v-card>
  </v-menu>
</template>

<script>
  import Vue from 'vue';
  import { C360Icon } from '../../../components/Icon';

  export default Vue.extend({
    name: 'C360AdvertisersSearch',

    components: { C360Icon },

    props: {
      /**
       * List of advertisers available to select.
       */
      items: {
        type: Array,
        required: true,
      },

      /**
       * List of recently selected advertisers.
       */
      recent: {
        type: Array,
        default: () => [],
      },

      /**
       * Indicates if component in loading state.
       */
      loading: {
        type: Boolean,
        default: false,
      },

      /**
       * Selected advertiser.
       */
      currentAdvertiser: {
        type: String,
        default: null,
      },

      /**
       * Text to display during the items loading.
       */
      loadingText: {
        type: String,
      },

      /**
       * Height of item element in pixels to calculate the virtual scroll.
       */
       itemHeight: {
        type: Number,
        default: 60,
      },
    },

    data() {
      return {
        open: false,
      };
    },

    methods: {
      onItemClick(item) {
        this.$emit('click:item', item);
      },
      onRecentClick(item) {
        this.$emit('click:recent', item);
      },
    },
  });
</script>
